/* Supra collection: filters, sort, pagination and column density without a page reload.
   Fetches the same page with ?section_id= and swaps the regions marked data-sg-region. */
(function () {
  'use strict';
  if (customElements.get('sg-collection')) return;

  var root = document.documentElement;
  var KEY = 'supra-density';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readDensity() {
    try {
      var saved = parseInt(localStorage.getItem(KEY), 10);
      if (saved === 2 || saved === 3 || saved === 4) return saved;
    } catch (e) {}
    return window.innerWidth < 750 ? 2 : 4;
  }

  class SgCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id');
      this.sheet = this.querySelector('[data-sg-sheet]');
      this.form = this.querySelector('[data-sg-filter-form]');
      this.sort = this.querySelector('[data-sg-sort]');
      this.sortBtn = this.querySelector('[data-sg-sort-btn]');
      this.sortList = this.querySelector('[data-sg-sort-list]');
      this.controller = null;
      this.timer = null;
      this.density = readDensity();

      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onPop = this.onPop.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onSheetClose = function () {
        root.removeAttribute('scroll-lock');
      };

      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('popstate', this.onPop);
      window.addEventListener('resize', this.onResize);
      if (this.sheet) this.sheet.addEventListener('close', this.onSheetClose);

      this.applyDensity(this.density);
      this.syncSort();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
      window.removeEventListener('popstate', this.onPop);
      window.removeEventListener('resize', this.onResize);
      if (this.sheet) this.sheet.removeEventListener('close', this.onSheetClose);
      window.clearTimeout(this.timer);
    }

    /* Custom sort menu */
    sortOptions() {
      return this.sortList ? Array.prototype.slice.call(this.sortList.querySelectorAll('[data-sg-sort-option]')) : [];
    }

    syncSort() {
      if (!this.sort || !this.sortBtn) return;
      var label = this.sortBtn.querySelector('[data-sg-sort-label]');
      var options = this.sortOptions();
      for (var i = 0; i < options.length; i++) {
        var on = options[i].getAttribute('data-value') === this.sort.value;
        options[i].setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && label) label.textContent = options[i].getAttribute('data-name');
      }
    }

    openSort(focusSelected) {
      if (!this.sortList || !this.sortList.hidden) return;
      this.sortList.hidden = false;
      this.sortBtn.setAttribute('aria-expanded', 'true');
      if (focusSelected) {
        var options = this.sortOptions();
        var current = options.filter(function (o) {
          return o.getAttribute('aria-selected') === 'true';
        })[0] || options[0];
        if (current) current.focus();
      }
    }

    closeSort(returnFocus) {
      if (!this.sortList || this.sortList.hidden) return;
      this.sortList.hidden = true;
      this.sortBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.sortBtn.focus();
    }

    chooseSort(option) {
      if (!this.sort) return;
      this.sort.value = option.getAttribute('data-value');
      this.syncSort();
      this.closeSort(true);
      this.sort.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onDocClick(event) {
      if (this.sortList && !this.sortList.hidden && !event.target.closest('[data-sg-sort-wrap]')) this.closeSort(false);
    }

    onKey(event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('[data-sg-sort-wrap]')) return;
      var key = event.key;
      var options = this.sortOptions();
      if (target === this.sortBtn) {
        if (key === 'ArrowDown' || key === 'ArrowUp') {
          event.preventDefault();
          this.openSort(true);
        }
        return;
      }
      var index = options.indexOf(target);
      if (index < 0) return;
      if (key === 'ArrowDown') {
        event.preventDefault();
        options[Math.min(index + 1, options.length - 1)].focus();
      } else if (key === 'ArrowUp') {
        event.preventDefault();
        options[Math.max(index - 1, 0)].focus();
      } else if (key === 'Home') {
        event.preventDefault();
        options[0].focus();
      } else if (key === 'End') {
        event.preventDefault();
        options[options.length - 1].focus();
      } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        this.chooseSort(target);
      } else if (key === 'Escape') {
        event.preventDefault();
        this.closeSort(true);
      } else if (key === 'Tab') {
        this.closeSort(false);
      }
    }

    applyDensity(value) {
      this.density = value;
      this.setAttribute('data-density', String(value));
      var effective = window.innerWidth < 750 && value === 4 ? 3 : value;
      var buttons = this.querySelectorAll('[data-sg-density]');
      for (var i = 0; i < buttons.length; i++) {
        var on = parseInt(buttons[i].getAttribute('data-sg-density'), 10) === effective;
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    onResize() {
      this.applyDensity(this.density);
    }

    openSheet() {
      if (!this.sheet || this.sheet.open) return;
      this.sheet.showModal();
      root.setAttribute('scroll-lock', '');
    }

    closeSheet() {
      if (this.sheet && this.sheet.open) this.sheet.close();
    }

    onClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-sg-sort-btn]')) {
        if (this.sortList.hidden) this.openSort(false);
        else this.closeSort(false);
        return;
      }

      var sortOption = target.closest('[data-sg-sort-option]');
      if (sortOption) {
        this.chooseSort(sortOption);
        return;
      }

      var densityButton = target.closest('[data-sg-density]');
      if (densityButton) {
        var value = parseInt(densityButton.getAttribute('data-sg-density'), 10);
        try {
          localStorage.setItem(KEY, String(value));
        } catch (e) {}
        this.applyDensity(value);
        return;
      }

      if (target.closest('[data-sg-sheet-open]')) {
        this.openSheet();
        return;
      }

      if (target.closest('[data-sg-sheet-close]') || target === this.sheet) {
        this.closeSheet();
        return;
      }

      var quick = target.closest('[data-sg-price-max]');
      if (quick && this.form) {
        var max = quick.getAttribute('data-sg-price-max');
        var fields = this.form.elements;
        for (var i = 0; i < fields.length; i++) {
          var name = fields[i].name || '';
          if (name.slice(-4) === '.lte') fields[i].value = max;
          if (name.slice(-4) === '.gte') fields[i].value = '';
        }
        this.queue();
        return;
      }

      var link = target.closest('a[data-sg-ajax]');
      if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        var url = new URL(link.href, window.location.origin);
        this.update(url.pathname + url.search, { scroll: link.hasAttribute('data-sg-scroll') });
      }
    }

    onChange(event) {
      var target = event.target;
      if (!target) return;
      if (target === this.sort || (this.form && this.form.contains(target))) this.queue();
    }

    onSubmit(event) {
      if (this.form && event.target === this.form) {
        event.preventDefault();
        this.queue(0);
      }
    }

    onPop() {
      var sortBy = new URLSearchParams(window.location.search).get('sort_by');
      if (this.sort) this.sort.value = sortBy || this.sort.getAttribute('data-default') || this.sort.value;
      this.syncSort();
      this.update(window.location.pathname + window.location.search, { history: 'none' });
    }

    queue(delay) {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(
        function () {
          this.update(this.buildUrl());
        }.bind(this),
        delay === undefined ? 250 : delay
      );
    }

    buildUrl() {
      var params = new URLSearchParams();
      if (this.form) {
        new FormData(this.form).forEach(function (value, key) {
          if (value !== '') params.append(key, value);
        });
      }
      if (this.sort && this.sort.value) params.set('sort_by', this.sort.value);
      var query = params.toString();
      return window.location.pathname + (query ? '?' + query : '');
    }

    update(url, options) {
      options = options || {};
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');

      var focused = document.activeElement;
      var focusName = focused && this.contains(focused) ? focused.getAttribute('name') : null;
      var focusValue = focused && this.contains(focused) ? focused.getAttribute('value') : null;

      var requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('section_id', this.sectionId);
      var cleanUrl = new URL(url, window.location.origin);
      cleanUrl.searchParams.delete('section_id');
      var clean = cleanUrl.pathname + cleanUrl.search;
      var self = this;

      fetch(requestUrl.toString(), { signal: this.controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('bad response');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelectorAll('[data-sg-region]');
          var current = self.querySelectorAll('[data-sg-region]');
          for (var i = 0; i < fresh.length; i++) {
            var name = fresh[i].getAttribute('data-sg-region');
            for (var j = 0; j < current.length; j++) {
              if (current[j].getAttribute('data-sg-region') === name) {
                current[j].innerHTML = fresh[i].innerHTML;
                break;
              }
            }
          }
          if (options.history !== 'none') window.history.pushState({}, '', clean);

          if (focusName) {
            var inputs = self.querySelectorAll('input');
            for (var k = 0; k < inputs.length; k++) {
              if (inputs[k].getAttribute('name') === focusName && inputs[k].getAttribute('value') === focusValue) {
                inputs[k].focus({ preventScroll: true });
                break;
              }
            }
          }

          self.classList.remove('is-loading');
          if (options.scroll) {
            var results = self.querySelector('[data-sg-results-top]');
            if (results) results.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          window.location.href = clean;
        });
    }
  }

  customElements.define('sg-collection', SgCollection);
})();
